import React, { useState, useEffect } from 'react';
import {
  authorizedPyInstance as py,
  authorizedInstance as rb,
} from '~/utils';
import { PageLayout, Navbar } from '~/components';
import { groupBy, upperFirst, camelCase } from 'lodash';
import { CardHeader, ListGroupItem, useFeatures } from '@cordata/buffet';
import { Card, ListGroup, CardDeck } from 'reactstrap';

import log from '~/utils/event/log';

const ResourceLibrary = () => {
  const [resourceList, setResourceList] = useState([]);
  const { hasAppIdentity } = useFeatures();

  useEffect(() => {
    py
      .get('/api/data/reference/reference-resource', {
        params: {
          sort: 'sortOrder,category,title',
          target: 'clinician',
        },
      })
      .then(r => r.data.data)
      .then(r => groupBy(r, c => c.attributes.category))
      .then(setResourceList)
      .catch(console.error);
  }, []);

  const handleClick = (rsrc) => {
    if (hasAppIdentity) {
      log.create({ action: `Support${upperFirst(camelCase(rsrc.attributes.resourceTitle))}` });
    }

    if (rsrc.attributes.resourceType === 'link') {
      window.open(rsrc.attributes.resourceLink, '_blank');
    } else {
      rb
        .get('get-s3-link', { params: { link: rsrc.attributes.resourceLink } })
        .then(r => r.data)
        .then(r => window.open(r.link, '_blank'));
    }
  };

  return (
    <PageLayout Header={Navbar} title="Resource Library">
      <CardDeck>
        {Object.keys(resourceList)?.map(category => (
          <Card>
            <CardHeader>
              <h5>{category}</h5>
            </CardHeader>

            <ListGroup flush>
              {resourceList[category].map(resource => (
                <ListGroupItem
                  onClick={() => handleClick(resource)}
                  className="text-primary cursor-pointer"
                >
                  {resource.attributes.resourceTitle}
                </ListGroupItem>
              ))}
            </ListGroup>
          </Card>
        ))}
      </CardDeck>
    </PageLayout>
  );
};

export default ResourceLibrary;
